import * as generic from "../generic";
import * as types from "../types";
import * as notifications from "../../notifications";
import { activeFunderSelector, activeEntityDocumentIdSelector } from "../../reducers";
import advisorhq from "../../apis/advisorhq";

export const selectEntityDocument = id => {
  return { type: types.SELECT_ENTITY_DOCUMENT, payload: id };
};

export const uploadEntityDocument = file => async (dispatch, getState) => {
  notifications.success("Uploading Entity Document...", file);
  const state = getState();
  const activeEntityDocumentId = activeEntityDocumentIdSelector(state);
  const formData = new FormData();
  formData.append("id", activeEntityDocumentId);
  formData.append("file", file, file.name);

  try {
    await advisorhq.post(`/life_settlement/api/entity_document/${activeEntityDocumentId}/upload_file/`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    let funderInfo = activeFunderSelector(getState());
    let activeFunderId = funderInfo.id;
    const endpoint = `/life_settlement/api/funder_entity/`;
    const activeFunderResponse = await advisorhq.get(endpoint, {
      params: { funder_id: activeFunderId },
    });
    dispatch({ type: types.FETCH_FUNDER_ENTITIES, payload: activeFunderResponse.data });

    notifications.success("Entity Document updated successfully");
  } catch (error) {
    notifications.error("Error uploading Entity Document");
    console.error(error);
  }
};

export const createEntityDocument = (...props) => generic.createEntity("entityDocument", ...props);
export const editEntityDocument = (...props) => generic.editEntity("entityDocument", ...props);
export const fetchEntityDocuments = () => generic.fetchEntityList("entityDocument");
export const deleteEntityDocument = (...props) => generic.deleteEntity("entityDocument", ...props);
export const uploadEntityDocumentFile = (...props) => generic.uploadFile("entityDocument", ...props);
export const deleteEntityDocumentFile = (...props) => generic.deleteFile("entityDocument", ...props);
